/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductNameType = {
    NnOrangeRisk: 'NN_ORANGE_RISK',
    NnOrangeBonus: 'NN_ORANGE_BONUS',
    NnOrangeInvest: 'NN_ORANGE_INVEST',
    NnOrangeCare: 'NN_ORANGE_CARE',
    NnOrangeBenefit: 'NN_ORANGE_BENEFIT',
    NnFufiUl: 'NN_FUFI_UL',
    NnFufiUlSingle: 'NN_FUFI_UL_SINGLE',
    NnFufiPseudoRsk: 'NN_FUFI_PSEUDO_RSK'
} as const;
export type ProductNameType = typeof ProductNameType[keyof typeof ProductNameType];


export function instanceOfProductNameType(value: any): boolean {
    for (const key in ProductNameType) {
        if (Object.prototype.hasOwnProperty.call(ProductNameType, key)) {
            if (ProductNameType[key as keyof typeof ProductNameType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductNameTypeFromJSON(json: any): ProductNameType {
    return ProductNameTypeFromJSONTyped(json, false);
}

export function ProductNameTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductNameType {
    return json as ProductNameType;
}

export function ProductNameTypeToJSON(value?: ProductNameType | null): any {
    return value as any;
}

export function ProductNameTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductNameType {
    return value as ProductNameType;
}

